module.exports = __webpack_public_path__ + "static/media/gu.2284e60e.svg";